// Empty module to replace Node.js specific modules in browser environment
export default {};
